'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = function Menu(props) {
  return _react2.default.createElement(
    'ul',
    _extends({}, props, {
      className: props.className }),
    props.children
  );
};

exports.default = Menu;


//////////////////
// WEBPACK FOOTER
// ./~/mesosphere-react-typeahead/lib/Menu.react.js
// module id = 2009
// module chunks = 2